import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServiceDetailContent from "../components/ServiceDetailContent";
import PageLoader from "../components/PageLoader";
import { fetchServiceCard, fetchMenu } from "../api";

export default function ServiceDetailPage() {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [subServices, setSubServices] = useState([]);

  useEffect(() => {
    setService(null);
    setNotFound(false);
    fetchServiceCard(id)
      .then(setService)
      .catch(() => setNotFound(true));
  }, [id]);

  useEffect(() => {
    if (!service) return;
    fetchMenu()
      .then((menuItems) => {
        const category = menuItems.find((m) => m.title === service.title && m.parent !== null);
        if (!category) return setSubServices([]);
        setSubServices(menuItems.filter((m) => m.parent === category.id).sort((a, b) => a.order - b.order));
      })
      .catch(() => setSubServices([]));
  }, [service]);

  useEffect(() => {
    document.title = service ? `${service.title} - Mr. Aali Online Technologies` : "Service - Mr. Aali Online Technologies";
  }, [service]);

  if (notFound) {
    return (
      <>
        <Header />
        <div className="h-16" />
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-white bg-navy text-center px-6">
          <h1 className="text-3xl font-bold mb-4">Service not found</h1>
          <Link to="/#services" className="text-accent-light hover:underline">
            Back to Services
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  if (!service) {
    return <PageLoader />;
  }

  return (
    <>
      <Header />
      <div className="h-16" />
      <ServiceDetailContent service={service} subServices={subServices} />
      <Footer />
    </>
  );
}
